import React from 'react';
import styles from '../LandingPage.module.css';

const CapabilitiesSection = () => {
  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '20px' }}>
        <div className={styles.pillLight}>🔹 GCC Capability Services</div>
        <h2 className={styles.sectionTitleLight}>Specialized capabilities for the modern GCC</h2>
        <p className={styles.sectionSubtitleLight}>Designed to power Global Capability Centers across enterprise platforms, AI, automation and workforce intelligence.</p>
        
        <div className={styles.capabilitiesGrid}>
          <div className={styles.capabilityCard}>
            <div className={styles.capabilityHeader}>
              <div className={styles.timelineIcon}>🔗</div>
              <h3>Enterprise Platforms for GCC Operations</h3>
            </div>
            <p className={styles.capabilityDesc}>Enable scalable business operations with enterprise-grade digital platforms integrated into your GCC ecosystem.</p>
            <ul className={styles.capabilityList}>
              <li>ServiceNow Implementation & Consulting</li>
              <li>Salesforce CRM Solutions</li>
              <li>Microsoft Dynamics 365</li>
              <li>Enterprise Workflow Automation</li>
              <li>Cloud & Integration Services</li>
            </ul>
          </div>
          
          <div className={styles.capabilityCard}>
            <div className={styles.capabilityHeader}>
              <div className={styles.timelineIcon}>🛡️</div>
              <h3>Quality Engineering & Automation</h3>
            </div>
            <p className={styles.capabilityDesc}>Deliver reliable, scalable and high-performance enterprise systems with advanced QA frameworks and automation strategies.</p>
            <ul className={styles.capabilityList}>
              <li>Automation Testing</li>
              <li>API & Performance Testing</li>
              <li>Regression Testing</li>
              <li>CI/CD Testing Pipelines</li>
              <li>QA for AI Systems</li>
            </ul>
          </div>

          <div className={styles.capabilityCard}>
            <div className={styles.capabilityHeader}>
              <div className={styles.timelineIcon}>🧠</div>
              <h3>AI & Machine Learning Solutions</h3>
            </div>
            <p className={styles.capabilityDesc}>Build intelligent GCC ecosystems with AI-powered automation, analytics and decision-making capabilities.</p>
            <ul className={styles.capabilityList}>
              <li>Generative AI Development</li>
              <li>Conversational AI</li>
              <li>Machine Learning Models</li>
              <li>NLP & AI Automation</li>
              <li>Data Analytics & Predictive Insights</li>
            </ul>
          </div>

          <div className={styles.capabilityCard}>
            <div className={styles.capabilityHeader}>
              <div className={styles.timelineIcon}>👥</div>
              <h3>GCC Talent & Workforce Solutions</h3>
            </div>
            <p className={styles.capabilityDesc}>Accelerate GCC hiring and workforce scalability through AI-powered talent acquisition and intelligent screening.</p>
            <ul className={styles.capabilityList}>
              <li>AI Hiring Platform (Prohirey)</li>
              <li>AI Candidate Screening (ToxBox AI)</li>
              <li>Talent Pipeline Management</li>
              <li>Workforce Intelligence</li>
              <li>Recruitment Automation</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapabilitiesSection;
